import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_EN: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'For men',
  components_header_media_2: 'For women',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Train smarter, feel better.',
  hero_button_text: 'Get started now',
  components_ressources_subheader_text: 'Guides and tips',
  components_ressources_span_text: 'It combines the earthy focus of yoga, the controlled precision of Pilates and the dynamic challenge of strength training to support a well-rounded and healthy lifestyle.',
  components_ressources_card_1_title: 'Yoga tips',
  components_ressources_card_1_text: 'Quick guide for better balance, breathing and flow.',
  components_ressources_card_2_title: 'Pilates tips',
  components_ressources_card_2_text: 'Simple tips to strengthen your core muscles and improve control.',
  components_notes_and_google_title_1: 'Build strength',
  components_notes_and_google_title_2: 'Yoga Tranquility',
  components_notes_and_google_title_3: 'Pilates core',
  media_content_section_multi_1_subheader_text: 'Training videos',
  media_content_section_multi_2_subheader_text: 'Yoga videos',
  media_content_section_multi_3_subheader_text: 'Pilates videos',
  text_media_1: 'Men',
  text_media_2: 'Women',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Back',
  page_media_content_menu_chest: 'Chest',
  page_media_content_menu_legs: 'Legs',
  page_media_content_menu_shoulders: 'Shoulders',
  page_media_content_menu_abdominals: 'Abdominals',
  components_text1_subheader_text: 'Healthy diet for your active life',
  components_text1_span_text: 'Healthy recipes that support your training and improve your well-being.',
  components_footer_text: 'Strengthen your body, balance your mind and move with meaning – your place for gym, yoga and pilates.',
};